<template>
<div class="uk-section">
    <div class="uk-margin-top-large uk-container uk-container-center uk-text-center">
        <h2 class="uk-margin-top" v-html="this.$store.getters.GetText.reports.title[this.$store.getters.Lang]"></h2>        
        <p v-html="this.$store.getters.GetText.reports.subtitle[this.$store.getters.Lang]"></p>
        
        <div v-show="addform" class="uk-container uk-margin-top uk-animation-scale-down">
            <div class=" uk-margin uk-align-center">
                <div class="uk-child-width-expand@s uk-text-center uk-margin" uk-grid>
                <!-- RU -->
                <div>
                <h4>{{ this.$store.getters.GetText.reports.add_title1[this.$store.getters.Lang]}}</h4>    
                <!-- Title -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.rep_title[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="titleRu" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon">
                    </div>
                </div>
                <!-- Author -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.author[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="authorRu" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" v-bind:placeholder="this.$store.getters.GetText.reports.author_place[this.$store.getters.Lang]" autocomplete="name">
                    </div>
                </div>
                <!-- Co-Author -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.coauthor[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">                    
                    <input v-model="coauthorRu" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" v-bind:placeholder="this.$store.getters.GetText.reports.coauthor_place[this.$store.getters.Lang]" autocomplete="name">
                    </div>
                </div> 
                <!-- Anotation -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.annotation[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <textarea  v-model="annotationRu" class="uk-textarea" rows="5" v-bind:placeholder="this.$store.getters.GetText.reports.text[this.$store.getters.Lang]" maxlength="2000"></textarea>
                    </div>
                </div> 


                </div>
                <!-- En -->
                
                <div>
                <h4>{{ this.$store.getters.GetText.reports.add_title2[this.$store.getters.Lang]}}</h4>
                <!-- Title -->    
                <div class="uk-margin">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.rep_title[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="titleEn" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon">
                    </div>
                </div> 
                <!-- Author -->    
                <div class="uk-margin">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.author[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="authorEn" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" v-bind:placeholder="this.$store.getters.GetText.reports.author_place[this.$store.getters.Lang]" autocomplete="name">
                    </div>
                </div> 
                <!-- Co-Author -->    
                <div class="uk-margin">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.coauthor[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                    <input v-model="coauthorEn" class="uk-input  uk-text-center" type="text" aria-label="Not clickable icon" v-bind:placeholder="this.$store.getters.GetText.reports.coauthor_place[this.$store.getters.Lang]" autocomplete="name">
                    </div>
                </div>
                <!-- Anotation -->
                <div class="uk-margin">
                <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.annotation[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">                    
                    <textarea v-model="annotationEn"  class="uk-textarea" rows="5" v-bind:placeholder="this.$store.getters.GetText.reports.text[this.$store.getters.Lang]" maxlength="2000"></textarea>
                    </div>
                </div> 
               
            </div>    
                
                
            </div>
            <!-- Dropzone -->
                <!-- Abstract -->
                <div v-if="this.$store.getters.GetBlock.anotations_files" class="uk-margin">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                        <div class="uk-placeholder uk-text-center uk-card uk-padding uk-background-muted uk-margin" ref="drop" v-html="this.$store.getters.GetText.reports.upload[this.$store.getters.Lang]"></div>
                        <p v-html="this.$store.getters.GetText.reports.abstract_not[this.$store.getters.Lang]"></p>
                    </div>
                </div>
                <!-- Abstract_oth -->
                <div v-if="this.$store.getters.GetBlock.anotations_other" class="uk-margin">
                    <label class="uk-form-label " for="form-stacked-text">{{ this.$store.getters.GetText.reports.abstract_oth[this.$store.getters.Lang]}}</label><br>
                    <div class="uk-inline uk-width-expand ">
                        <div class="uk-placeholder uk-text-center uk-card uk-padding uk-background-muted uk-margin" ref="dropOther" v-html="this.$store.getters.GetText.reports.upload[this.$store.getters.Lang]"></div>
                        <p v-html="this.$store.getters.GetText.reports.abstract_oth_not[this.$store.getters.Lang]"></p>
                    </div>
                </div>
            <!--button class="uk-button uk-button-primary uk-width-medium" v-on:click="this.clearFile()">{{ this.$store.getters.GetText.reports.clear_file[this.$store.getters.Lang] }}</button-->
             
            </div>   
        <button v-if="this.$store.getters.GetBlock.reports" class="uk-button uk-button-danger uk-width-medium" :disabled="this.filled" v-on:click="this.send()">{{ this.$store.getters.GetText.reports.send[this.$store.getters.Lang] }}</button>  
        </div>
        <button v-if="this.$store.getters.GetBlock.reports" class="uk-button uk-button-primary uk-margin uk-width-medium" v-on:click="this.showadd()">{{ this.addBottonTitle }}</button>
        
    </div>
    <List/>
</div>

</template>
<script>
import api from '@/api'
import dropzone from 'dropzone'
import List from '@/components/ReportsView.vue'
export default {
    components: {
        List
    },
    data(){
        return{
            
            addFlag:true,
            addBottonTitle:this.$store.getters.GetText.reports.add[this.$store.getters.Lang],
            addform:false,
            drop:null,
            dropOther:null,
            filled: true,
            corFile:true,
            authorId:this.$store.getters.User.id,
            titleRu:'',
            titleEn:'',
            authorRu:'',
            authorEn:'',
            coauthorRu:'',
            coauthorEn:'',
            annotationRu:'',
            annotationEn:'',
            abstractRu:{},
            abstractEn:{}
        }
    },
    mounted() {
        this.Flag=false        
    },
    updated(){
        this.addBottonTitle=this.addFlag?this.$store.getters.GetText.reports.add[this.$store.getters.Lang]:this.$store.getters.GetText.reports.cancel[this.$store.getters.Lang]            
        
        if (this.titleRu.length>10 && this.titleEn.length>10 && this.authorRu.length>3 && this.authorEn.length>3 && this.annotationEn.length>10 && this.annotationRu.length>10){
            this.filled=false
        } else {
            this.filled=true
        }

    },
    methods:{
        push_file(arr,files){
            if (files){
                files.forEach(file=>{                
                    arr.append('abstracts[]',file)
                })
            }
        },
        send(){
            //var mask_filename=[]
            //var ru=false
            //var en=false
            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            var abstracts= new FormData()
            var abs ={}
            var oth ={}
            if (this.$store.getters.GetBlock.anotations_files){
                abs = this.drop.getAcceptedFiles()
                this.push_file(abstracts,abs)                
                if (this.$store.getters.GetBlock.anotations_other){
                    oth = this.dropOther.getAcceptedFiles()
                    this.push_file(abstracts,oth)
                }                
            } else if (this.$store.getters.GetBlock.anotations_other){
                oth = this.dropOther.getAcceptedFiles()
                this.push_file(abstracts,oth)
            }

            //if (files){
            //    files.forEach(file=>{                
            //        abstracts.append('abstracts[]',file)
            //    })
            //}
            

            abstracts.append('title_ru',this.titleRu)
            abstracts.append('title_en',this.titleEn)
            abstracts.append('author_id',this.authorId)
            abstracts.append('author_ru',this.authorRu)
            abstracts.append('author_en',this.authorEn)
            abstracts.append('co_author_ru',this.coauthorRu)
            abstracts.append('co_author_en',this.coauthorEn)
            abstracts.append('annotation_ru',this.annotationRu)
            abstracts.append('annotation_en',this.annotationEn)
            
            api.post('api/auth/abstract/create',abstracts,config).then(res=>{
                    res
                    this.$router.go()                    
                }).catch(error=>{
                    console.log(error.data)
                })

        },
        initDrop(){
            this.drop = new dropzone(this.$refs.drop,{
                    url: "/",
                    maxFilesize: 20,
                    maxFiles: 2,
                    autoProcessQueue: false,
                    createImageThumbnails: false,
                    maxThumbnailFilesize: 2,
                    acceptedFiles: '.pdf,.doc,.docx',
                    addRemoveLinks: true,
                    accept: function(file, done) {                            
                            //const isInclude = file.som(name=> name=== file.name)  // уже есть ?
                            if ((file.name.toLowerCase().indexOf('_en.')==-1)&&(file.name.toLowerCase().indexOf('_ru.')==-1)){
                                done('Does not match naming pattern "_ru.docx" or "_en.docx"'); //  отклоняем попытку добавить                                
                            }                                
                            else {
                                //filles.push(file.name); // сохраняем имя файла
                                done();  // все ок. 
                                } 
                            }                   
            })
        },
        initDropOther(){            
            this.dropOther = new dropzone(this.$refs.dropOther,{
                    url: "/",
                    maxFilesize: 50,                    
                    autoProcessQueue: false,
                    createImageThumbnails: false,
                    maxThumbnailFilesize: 2,
                    acceptedFiles: '*.zip,.pdf,.doc,.docx',
                    addRemoveLinks: true,
                    
                    accept: function(file, done) {                            
                            //const isInclude = file.som(name=> name=== file.name)  // уже есть ?
                            if ((file.name.toLowerCase().indexOf('_expert.')==-1)&&(file.name.toLowerCase().indexOf('_export.')==-1)){
                                done('Does not match naming pattern "*_expert.*" or "*_export.*"'); //  отклоняем попытку добавить
                                done();
                            }                                
                            else {
                                //filles.push(file.name); // сохраняем имя файла
                                done();  // все ок. 
                                } 
                            }                   
            })
            this.dropOther.on('removedfile',(file)=>{
                 this.abstractsForRemove.push(file.id)
                //console.log(this.abstractsForRemove)
            })
        },
        clearFile(){
            this.drop.removeAllFiles(true)
            //this.initDrop()  
        },
        showadd(){
            this.addFlag=false
            this.addform=this.addform?false:true 
            this.titleRu=''
            this.titleEn=''
            this.authorRu=''
            this.authorEn=''
            this.coauthorRu=''
            this.coauthorEn=''
            this.annotationRu=''
            this.annotationEn=''            
            if (this.$store.getters.User.lang=='En'){
                this.authorRu=this.$store.getters.User.name
            } else {
                this.authorEn=this.$store.getters.User.name
            }

            

            if (this.addform){
                if(this.$store.getters.GetBlock.anotations_files){this.initDrop()}
                if(this.$store.getters.GetBlock.anotations_other){this.initDropOther()}
            } else {
                this.addFlag=true
                if(this.$store.getters.GetBlock.anotations_files){
                this.drop.destroy()                
                this.$refs.drop=null
                this.$refs.drop.value=''
                }
                if(this.$store.getters.GetBlock.anotations_other){
                this.dropOther.destroy()                
                this.$refs.dropOther=null
                this.$refs.dropOther.value=''
                }
            }
        },
    }
}
</script>
